import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withMainLayout } from "../view/LayoutHOCs";
// import { getParams } from "../view/urlService";
import * as layoutService from "../view/layoutService";
import { useHistory } from "react-router-dom";
import LicenseCard from "./LicenseInfoSection";
import * as licenseService from "./licenseService";
// import { Spinner } from "../view/Spinner";
import { InfoBoxes } from "../info-boxes/InfoBoxes";

const breadcrumbs = [
    {
        text: "Home",
        redirectTo: "/",
        iconClassName: "icon-home"
    },
    {
        text: "License",
        redirectTo: "/license",
    }
]

function LicensePage({ userCapability }) {

    // const params = getParams();
    const history = useHistory();
    const [loading, setLoading] = useState(true);

    //Hide pages with capability = -1, and even if the url is copied then logout the user directly
    //#region Set User Capabilities
    const checkLicenseCapability = async () => {
        try {
            if (userCapability) {
                const capability = userCapability.find(item =>
                    item.component === "license" && item.type === "page")?.permission;
                if (capability === -1) {
                    sessionStorage.removeItem('access_token');
                    window.location.reload();
                }
            }
        } catch (error) {
            // console.error('Error:', error);
        }
    };

    useEffect(() => {
        checkLicenseCapability();
        /* eslint-disable react-hooks/exhaustive-deps */
    }, []);
    //#endregion

    const fetchData = async () => {
        try {
            layoutService.setPageTitle("License");
            layoutService.setBreadcrumbs(breadcrumbs);
            await licenseService.loadLicense();
            await licenseService.loadMachineData();
            setLoading(false);
        } catch (error) {
            // console.error('Error:', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [history.location]);


    return (
        <div className="license-page">
            <InfoBoxes />
            {/* {loading && <Spinner />} */}
            <LicenseCard loading={loading} />
        </div>
    )

}

function mapStateToProps(state) {
    const auth = state.auth;
    return {
        userCapability: auth.userCapability,
    }
}

export default withMainLayout(connect(mapStateToProps)(LicensePage));